import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSliderModule } from '@angular/material/slider';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { ModalContentComponent } from './components/modal-content/modal-content.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { GeoMapContainerComponent } from './geo-map-container.component';
import { GeoMapRoutingModule } from './geo-map.routing.module';

@NgModule({
  declarations: [GeoMapContainerComponent, ModalContentComponent, LineChartComponent],
  imports: [
    CommonModule,
    GeoMapRoutingModule,
    MatIconModule,
    MatSelectModule,
    MatDialogModule,
    BaseChartDirective,
    MatButtonModule,
    MatSliderModule,
    MatRadioModule,
    FormsModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDividerModule,
  ],
})
export class GeoMapModule {}
